var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-table",
    {
      staticClass: "table",
      attrs: {
        multiple: _vm.multiple,
        "no-data-text": "No tienes conceptos presupuestarios",
        data: _vm.budgetConcepts
      },
      scopedSlots: _vm._u([
        {
          key: "default",
          fn: function(ref) {
            var data = ref.data
            return _vm._l(data, function(tr, indextr) {
              return _c(
                "vs-tr",
                { key: indextr, attrs: { data: tr } },
                [
                  _c(
                    "vs-td",
                    { attrs: { data: data[indextr].budgetConcept } },
                    [_vm._v(" " + _vm._s(tr.budgetConcept.label) + " ")]
                  ),
                  _c("vs-td", { attrs: { data: data[indextr] } }, [
                    _vm._v(" " + _vm._s(_vm._f("amount")(tr.amount)) + " ")
                  ])
                ],
                1
              )
            })
          }
        }
      ]),
      model: {
        value: _vm.budgetConceptsSelected,
        callback: function($$v) {
          _vm.budgetConceptsSelected = $$v
        },
        expression: "budgetConceptsSelected"
      }
    },
    [
      _c(
        "template",
        { slot: "thead" },
        [
          _c("vs-th", [_vm._v("Concepto Presupuestario")]),
          _c("vs-th", [_vm._v("Monto ($)")])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }